import { Project_Activity } from "@/generated/graphql";

const isHoursUnconfirmed = (activities: Project_Activity[]): boolean => {
  if (activities.length === 0) {
    return false;
  }

  return activities.some(({ requested_hours, confirmed_hours }) =>
    Boolean(requested_hours) && !confirmed_hours);
}

export default isHoursUnconfirmed;